module.exports = __webpack_public_path__ + "img/volume-off-fill.03351294.svg";